import { scrollTo } from '../utils/utils';

export class Header {
  private burger: HTMLElement | null;
  private menu: HTMLElement | null;
  private menuLinks: NodeListOf<HTMLAnchorElement>;

  constructor() {
    this.burger = document.querySelector('.header-primary__burger-button');
    this.menu = document.querySelector('.header-primary__menu-social');
    this.menuLinks =
      document.querySelectorAll<HTMLAnchorElement>('a[href^="#"]');
    this._init();
  }

  private _init(): void {
    this._setupBurgerToggle();
    this._setupMenuLinks();
    this._setupScrollSpy();
  }

  private _setupBurgerToggle(): void {
    this.burger?.addEventListener('click', () => {
      const isActive = this.burger?.classList.contains(
        'header-primary__burger-button--active'
      );

      this.burger?.classList.toggle(
        'header-primary__burger-button--active',
        !isActive
      );
      this.menu?.classList.toggle(
        'header-primary__menu-social--active',
        !isActive
      );
      this.menu?.classList.toggle(
        'header-primary__menu-social--inactive',
        isActive
      );
    });
  }

  private _setupMenuLinks(): void {
    this.menuLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        if (
          link.pathname === window.location.pathname &&
          link.hostname === window.location.hostname &&
          link.hash
        ) {
          event.preventDefault();

          const targetId = link.hash.substring(1);
          const targetElem = document.getElementById(targetId);

          if (targetElem) {
            scrollTo(targetElem);

            // Fermer le menu mobile après clic
            this.burger?.classList.remove(
              'header-primary__burger-button--active'
            );
            this.menu?.classList.remove('header-primary__menu-social--active');
            this.menu?.classList.add('header-primary__menu-social--inactive');
          }
        }
      });
    });
  }

  private _setupScrollSpy(): void {
    const sectionElements = document.querySelectorAll<HTMLElement>(
      'section[id], footer[id]'
    );
    const linkMap = new Map<string, HTMLAnchorElement>();
    const offsetMargin = 100;

    this.menuLinks.forEach((link) => {
      const href = link.getAttribute('href');
      if (href?.startsWith('#')) {
        const id = href.substring(1);
        linkMap.set(id, link);
      }
    });

    const onScroll = (): void => {
      const scrollPosition =
        window.scrollY +
        (document.querySelector('.header-primary') as HTMLElement)
          ?.offsetHeight +
        offsetMargin;

      let currentSectionId: string | null = null;

      sectionElements.forEach((section) => {
        if (section.offsetTop <= scrollPosition) {
          currentSectionId = section.id;
        }
      });

      // ✅ Vérifie si on est tout en bas de la page
      const lastSection = sectionElements[sectionElements.length - 1];
      let nearBottom = false;

      if (lastSection) {
        const footerStyle = window.getComputedStyle(lastSection);
        const footerPaddingBottom = parseInt(
          footerStyle.paddingBottom || '0',
          10
        );

        const footerBottom =
          lastSection.offsetTop +
          lastSection.offsetHeight +
          footerPaddingBottom;

        nearBottom = window.scrollY + window.innerHeight >= footerBottom - 2;
      }

      if (nearBottom) {
        const lastSection = sectionElements[sectionElements.length - 1];
        if (lastSection) {
          currentSectionId = lastSection.id;
        }
      }

      // Applique la classe active
      linkMap.forEach((link, id) => {
        link.classList.toggle('menu-link--active', id === currentSectionId);
      });
    };

    window.addEventListener('scroll', onScroll);
    onScroll(); // vérification initiale
  }
}

// Et enfin, instance unique
export const header = new Header();
